import React, { Fragment } from "react";
import { Button, Modal } from "antd";
import { confirmUpdate } from "../popup/confirm";

const confirm = Modal.confirm;

const BtnFormSubmit = ({ onClick }) => {
  const confirmShow = () => {
    confirm({
      ...confirmUpdate,
      onOk: onClick
    });
  };

  return (
    <Fragment>
      <Button
        type="primary"
        htmlType="submit"
        size="large"
        className="offer-card-btn"
        onClick={confirmShow}
      >
        Сохранить
      </Button>
    </Fragment>
  );
};

export default BtnFormSubmit;
